export default function({username, password}) {
    return this.fetch("oauth/token", {
        method:  "post",
        headers: {Authorization: 'Basic ' + btoa(username + ':' + password)},
        body:    {grant_type: "client_credentials"}
    })
    .then(response => response.json())
    .then(response => this.setToken(response.access_token));
}